import request from "@/utils/request"
export const queryProductList = (data)=>{
    return request({
        url:"/app/products/list",
        method:"GET",
        params:data
    })
}